import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=b980893e&"
import script from "./Canvas.vue?vue&type=script&lang=js&"
export * from "./Canvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports